module.exports = __webpack_public_path__ + "static/media/guide4.3870c043.png";